import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/nevcap-logo.svg'
import _imports_1 from '../../../assets/images/person.svg'


const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "fixed top-0 z-10 w-full bg-white backdrop-blur-lg border-gray-200 border-b" }
const _hoisted_3 = { class: "flex h-[70px] mx-auto max-w-4xl justify-between items-center" }
const _hoisted_4 = { class: "flex items-center gap-6 lg:order-2" }
const _hoisted_5 = { class: "relative inline-block" }
const _hoisted_6 = { class: "px-4 py-4 border-b border-gray-100" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = { class: "h-9 w-9 rounded-full bg-[#f6f1ec] flex items-center justify-center text-xs font-semibold text-gray-700" }
const _hoisted_9 = { class: "block text-sm font-semibold text-gray-900" }
const _hoisted_10 = { class: "block text-xs text-gray-500 truncate" }
const _hoisted_11 = { class: "py-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "border-t border-gray-100 mt-2 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ShieldCheckIcon = _resolveComponent("ShieldCheckIcon")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_Cog6ToothIcon = _resolveComponent("Cog6ToothIcon")!
  const _component_ArrowRightOnRectangleIcon = _resolveComponent("ArrowRightOnRectangleIcon")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("a", {
          class: "flex items-center",
          href: "/"
        }, [
          _createElementVNode("img", {
            alt: "Nevcap Logo",
            class: "mr-3 h-8 sm:h-8",
            src: _imports_0
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            id: "hs-mega-menu-basic-dr",
            class: "text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap",
            to: "/dashboard"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Home ")
            ])),
            _: 1
          }),
          (_ctx.isCommunityPlus)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                id: "hs-mega-menu-basic-dr",
                class: "text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap",
                to: "/academy"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" Academy ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user?.role === 'admin')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                id: "hs-mega-menu-basic-dr",
                class: "text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap",
                to: "/dashboard/directory"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Directory ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            id: "hs-mega-menu-basic-dr",
            class: "text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap",
            to: "/dashboard/events"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Events ")
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, {
            id: "hs-mega-menu-basic-dr",
            class: "text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap",
            to: "/dashboard/account",
            type: "button"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" My Account ")
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DropdownMenu, null, {
              trigger: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("button", {
                  "aria-expanded": "false",
                  class: "flex items-center justify-center text-sm w-10 h-10 bg-[#262223] border border-[#d7c0ae] rounded-full md:me-0 focus:ring-4 focus:ring-[#d7c0ae]",
                  type: "button"
                }, [
                  _createElementVNode("span", { class: "sr-only" }, "Open user menu"),
                  _createElementVNode("span", { class: "fill-white" }, [
                    _createElementVNode("img", {
                      alt: "",
                      class: "h-5 w-5",
                      src: _imports_1
                    })
                  ])
                ], -1)
              ])),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user?.fullName?.[0] || 'N'), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user?.fullName), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.user ? _ctx.user.email : ''), 1)
                    ])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_11, [
                  (_ctx.user?.role === 'admin')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                        _createVNode(_component_router_link, {
                          class: "flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                          to: "/administrator"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ShieldCheckIcon, { class: "h-4 w-4 text-gray-500" }),
                            _cache[7] || (_cache[7] = _createTextVNode(" Admin Panel "))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      class: "flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                      to: "/dashboard"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_HomeIcon, { class: "h-4 w-4 text-gray-500" }),
                        _cache[8] || (_cache[8] = _createTextVNode(" Dashboard "))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      class: "flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                      to: "/dashboard/settings"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Cog6ToothIcon, { class: "h-4 w-4 text-gray-500" }),
                        _cache[9] || (_cache[9] = _createTextVNode(" Settings "))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_13, [
                    _createElementVNode("a", {
                      class: "flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-gray-700 hover:bg-gray-100",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, [
                      _createVNode(_component_ArrowRightOnRectangleIcon, { class: "h-4 w-4 text-gray-500" }),
                      _cache[10] || (_cache[10] = _createTextVNode(" Sign out "))
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}